import { useEffect, useState } from "react"
import { getWeeklyCount } from "../env"
const RefundCounter = () => {
	const [orderDigitsSplit, setorderDigitsSplit] = useState([0, 0, 0, 0, 0])

	async function checkOrders() {
		setorderDigitsSplit(await getWeeklyCount())
		
	}
	useEffect(() => {
		checkOrders()
	}, [])

	return (
		<div className=" mx-auto mt-6 bg-[url(/src/bgimages/bg-erstattungen.png)] bg-cover text-center pt-12 md:pt-24 pb-24">
			<div className="max-w-[1200px] mx-auto">
				<h2 className="mt-0 mb-12 text-center font-Alpro text-[36px] uppercase tracking-wider text-white md:mb-12 lg:text-[42px]">NOCH MÖGLICHE ERSTATTUNGEN</h2>
				<div className="mx-auto flex justify-center gap-2 self-center text-white drop-shadow-[0_4px_27px_rgba(0,0,0,0.25) mb-12">
					{orderDigitsSplit.map((item, index) => (
						<div key={index}>
							<span className="refund-item text-[#E6137F] rounded-lg bg-white p-4  py-1 font-Alpro text-[42px] md:text-[62px]">{item}</span>
						</div>
					))}
				</div>
				<div className="max-w-[90%] md:max-w-full mx-auto">
					<p className="mx-auto text-center text-[16px] font-[500] leading-[22px] text-white lg:max-w-[75%] lg:text-[18px] lg:leading-[37px]">Aktionszeitraum vom 05.01.2026 - 08.05.2026. Kassenbon-Upload möglich bis 08.05.2026. Limitiert auf 50.000
						Erstattungen gesamt. Teilnahme ab 18 Jahren. Der originale Rechnungsbeleg ist aufzubewahren. Eine Teilnahme pro Haushalt und IBAN.</p>
					<p className="mx-auto text-center text-[16px] font-[500] leading-[22px] text-white lg:max-w-[75%] lg:text-[18px] lg:leading-[37px]"> Weitere Informationen in den <a href="/teilnahmebedingungen" target="_blank" className="underline">Teilnahmebedingungen</a>.</p>
				</div>
			</div>
		</div >
	)
}

export default RefundCounter
